export default {
  hero_title: "轻松实现欧盟CBAM碳合规",
  hero_subtitle: "专为中小企业设计的碳计算平台，基于欧盟官方/自定义因子，快速生成合规报告。",
  what_is_taxecobit: "什么是TaxEcoBit？",
  taxecobit_description:
    "TaxEcoBit是一个为受欧盟碳边境调节机制(CBAM)影响的企业构建的合规自动化平台。我们帮助进口商、制造商和中小企业计算产品级碳排放，生成CBAM合规报告，并降低监管风险。",
  taxecobit_benefits: "使用TaxEcoBit，用户可以：",
  benefit_accurate_calculations: "使用官方和自定义排放因子进行精确的碳计算",
  benefit_cbam_documents: "生成可直接提交的CBAM文档",
  benefit_carbon_cost_tracking: "监控碳成本影响并优化运营效率",
  benefit_api_integration: "通过API与ERP和供应链系统无缝集成合规工作流程",
  taxecobit_conclusion:
    "通过替代手工电子表格和咨询依赖，TaxEcoBit以更低的运营成本实现更快、更可靠的合规。",
  register_now: "立即注册",
  experience_calculator: "体验CBAM计算器",
  try_cbam_calculator: "使用CBAM计算器",
  try_cbam_quick_check: "试用CBAM快速检测",
  download_sample_report: "下载示例报告",
  pdf_report: "PDF报告",
  excel_report: "Excel报告",
  precise: "精确",
  how_it_works: "操作方法",
  precise_description: "基于欧盟官方/自定义因子，计算误差<5%，满足合规要求。",
  efficient: "高效",
  efficient_description: "支持批量计算，自动生成PDF/Excel报告，配置灵活。",
  sme_focused: "专注中小企业",
  sme_focused_description: "无需专业背景，界面友好，易于上手。",
  api_support: "API支持",
  api_support_description: "轻松与ERP/电商系统集成，实现自动化合规报告。",
};
